import React from 'react';
import { styled } from '../../../stitches.config';
import { paddingVariants, flexVariants, backgroundColorVariants } from '../../styles/variants';

export const Flex = styled('div', {
  display: 'flex',

}, paddingVariants, flexVariants, backgroundColorVariants);
